import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LayoutAuth from '../../components/LayoutAuth/index';
import FormForgotPassword from './components/FormForgotPassword';
import { Helmet } from 'react-helmet-async';
import { Box, styled, useMediaQuery, useTheme } from '@mui/material';

const ForgotPassword = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));

  const handleSuccess = () => {
    setIsSuccess(true);
    // Add any additional success handling here
  };
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      {/* {mdDown ? <Whitespace /> : null} */}
      <LayoutAuth
        linkHelperText={t('forgot_password.linkHelperText')}
        linkHelperMessage={t('forgot_password.linkHelperMessage')}
        linkHelper="/sign-up"
        title={isSuccess ? '' : t('forgot_password.title')}
        text={isSuccess ? '' : t('forgot_password.text')}
        showMagicalIcon={isSuccess ? false : true}
      >
        <FormForgotPassword onSuccess={handleSuccess} />
      </LayoutAuth>
    </>
  );
};
export default ForgotPassword;
